export const SUPPORTED_LANGUAGES = ['ar', 'en', 'fr'] as const
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export function normalizeAppLanguage(value: string | null | undefined): AppLanguage {
  if (value?.startsWith('ar')) return 'ar'
  if (value?.startsWith('fr')) return 'fr'
  if (value?.startsWith('en')) return 'en'
  return 'ar'
}

export function isRtlLanguage(language?: string | null): boolean {
  return normalizeAppLanguage(language) === 'ar'
}

export function applyDocumentDirection(language?: string | null): void {
  const lang = normalizeAppLanguage(language)
  const dir = lang === 'ar' ? 'rtl' : 'ltr'
  document.documentElement.setAttribute('lang', lang)
  document.documentElement.setAttribute('dir', dir)
  document.body.setAttribute('dir', dir)
}

export function getSortLocale(language?: string | null): string {
  const lang = normalizeAppLanguage(language)
  if (lang === 'ar') return 'ar'
  if (lang === 'fr') return 'fr'
  return 'en'
}
